import { createFileRoute, Outlet } from "@tanstack/react-router"

import { Crumb } from "@/utilities/types/local"

export const Route = createFileRoute("/_authenticated/account/vehicles")({
  component: Outlet,
  loader: () => {
    return { crumb: { translationKey: "account.vehicles" } as Crumb }
  },
})
